"use client";

import React from "react";
import { Baby, Headset, UserCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const policyCards = [{
  id: "user-rights",
  title: "用户权利",
  description: "我们致力于保障您在平台上的各项合法权益。您拥有访问、更正、删除个人数据以及撤回同意的权利。我们提供简便的工具，让您随时掌控自己的信息，确保您的数字生活安全无忧。",
  icon: UserCheck,
  hasBadge: false,
  badgeText: "",
  buttonText: "联系支持",
  buttonLink: "/FeedbackPage"
}, {
  id: "childrens-privacy",
  title: "儿童隐私",
  description: "我们高度重视未成年人的隐私安全。平台采取了专门的、更严格的保护措施来处理儿童的个人信息。未经监护人明确同意，我们绝不会收集或使用儿童数据，为孩子们营造一个纯净的网络环境。",
  icon: Baby,
  hasBadge: true,
  badgeText: "特别保护",
  buttonText: "联系支持",
  buttonLink: "/FeedbackPage"
}];
export default function UserRightsAndChildrensPrivacy() {
  return <section id="用户权利与儿童隐私" className="bg-background py-16 md:py-24 px-4">
      <div className="container mx-auto max-w-3xl flex flex-col gap-8">
        <div className="text-center mb-4">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">
            隐私与权利保障
          </h2>
          <p className="font-sans text-muted-foreground text-lg max-w-2xl mx-auto">
            透明、安全、可控是我们处理您个人信息的核心原则。
          </p>
        </div>

        <div className="flex flex-col gap-8">
          {policyCards.map((card, i) => {
          const Icon = card.icon;
          return <Card key={card.id} data-index={i} className="border-2 border-border rounded-[24px] shadow-[0_4px_0_0_var(--color-border)] bg-card overflow-hidden transition-transform hover:-translate-y-1 duration-300">
                <CardHeader className="pb-4">
                  <div className="flex items-center justify-between gap-4 flex-wrap">
                    <CardTitle className="font-default text-[var(--color-secondary)] text-2xl md:text-3xl font-bold flex items-center gap-3">
                      <div className="p-2 bg-[var(--color-secondary)]/10 rounded-2xl">
                        <Icon className="w-7 h-7 text-[var(--color-secondary)]" />
                      </div>
                      {card.title}
                    </CardTitle>
                    {card.hasBadge && <Badge className="bg-[var(--color-chart-3)] text-black hover:bg-[var(--color-chart-3)]/90 border-transparent font-bold text-sm px-3 py-1 rounded-xl shadow-sm">
                        {card.badgeText}
                      </Badge>}
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-foreground/80 text-base md:text-lg leading-relaxed">
                    {card.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-2 pb-6">
                  <Button asChild className="bg-[var(--color-chart-1)] text-white hover:bg-[var(--color-chart-1)]/90 border-b-[3px] border-black/20 active:border-b-0 active:translate-y-[3px] transition-all rounded-xl font-bold text-base h-12 px-6 w-full sm:w-auto shadow-sm">
                    <Link to={card.buttonLink}>
                      <Headset className="w-5 h-5 mr-2" />
                      {card.buttonText}
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}